module.exports = __webpack_public_path__ + "static/media/Breast Surgery-Breast Surgery Intake-1@3x.1a483ff0.png";